/* eslint-disable eqeqeq */
// 格式化日期为M月D日
export function formatDateToMD(value: string | number) {
  var dateString = value + '';
  var dateArray = dateString.split('-');
  var result = parseInt(dateArray[1]) + '月' + parseInt(dateArray[2]) + '日';
  return result;
}
//将年月日格式化为2023-07-21 17:00:58
export function formatDateToYMDHMS(value: string | number) {
  value = value + '';
  if (value.length < 13) {
    return '';
  }
  return formatDateToYMD(value) + ' ' + formatDateToSecond(value.substring(8, 15));
}

//将年月日格式化为XXXX/XX/XX 或 XXXX-XX-XX type传"/"或""-"
export function formatDateToYMD(value: string | number, type: string = '-') {
  value = value + '';
  if (value.length < 9) {
    return '';
  }
  return value.substring(0, 4) + type + value.substring(4, 6) + type + value.substring(6, 8);
}
//将年月日格式化为XX-XX-XX
export function formatDateToNewYMD(value: string | number) {
  value = value + '';
  return value.substring(4, 6) + '-' + value.substring(6, 8);
}
//将时分格式化为XX:XX
export function formatDateToHour(value: string | number) {
  value = value + '';
  if (value.length < 4) {
    return '';
  }
  return value.substring(0, 2) + ':' + value.substring(2, 4);
}
//将时分秒格式化为XX:XX:XX
export function formatDateToSecond(value: string | number) {
  value = value + '';
  if (value.length < 5 || value.length > 6) {
    return '';
  }
  if (value.length == 5) {
    value = '0' + value;
  }
  return value.substring(0, 2) + ':' + value.substring(2, 4) + ':' + value.substring(4, 6);
}
// 格式化日期为(M.D-M.D)
export function formatDate(value: string | number) {
  var dateString = value + '';
  var dateArray = dateString.split('-');
  var result = parseInt(dateArray[1]) + '.' + parseInt(dateArray[2]);
  return result;
}

// 获取客户端时间
export function getNowDateTime() {
  var now = new Date();
  var year = now.getFullYear(); //得到年份
  var month = now.getMonth() + 1; //得到月份
  var date = now.getDate(); //得到日期
  var hour = now.getHours(); //得到小时数
  var minute = now.getMinutes(); //得到分钟数
  var second = now.getSeconds(); //得到秒数
  return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
}
